import { Input } from 'antd';
import { CiCircleRemove, CiSearch } from 'react-icons/ci';
import clsx from 'clsx';
import ConditionalRender from '../ConditionalRender';
import styles from './SearchBar.module.scss';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Width is left to the consumer; the field fills whatever box it is given. */
  className?: string;
}

/** Presentational only -- debouncing and querying belong to the caller. */
const SearchBar = ({ value, onChange, placeholder = 'SEARCH', className }: SearchBarProps) => {
  const handleClear = () => onChange('');

  return (
    <div className={clsx(styles.wrapper, className)}>
      <Input
        className={styles.input}
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        suffix={
          <span className={styles.suffix}>
            <ConditionalRender visible={!!value} hideFallback>
              <button type="button" className={styles.clear} aria-label="Clear search" onClick={handleClear}>
                <CiCircleRemove />
              </button>
            </ConditionalRender>
            <CiSearch className={styles.icon} aria-hidden="true" />
          </span>
        }
      />
    </div>
  );
};

export default SearchBar;
